import React from "react";
import { StepperProps } from "./types";
import { StepperProvider } from "./StepperContext";
import { StepperHeader } from "./StepperHeader";

export const Stepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  onStepChange,
  onComplete,
  onStepComplete,
  orientation = "horizontal",
  variant = "default",
  size = "md",
  children,
}) => {
  return (
    <StepperProvider
      steps={steps}
      initialStep={activeStep}
      onStepChange={onStepChange}
      onStepComplete={onStepComplete}
      onComplete={onComplete}
    >
      <div
        className={`stepper ${orientation === "vertical" ? "stepper-vertical" : "stepper-horizontal"}`}
        data-variant={variant}
        data-size={size}
      >
        <StepperHeader steps={steps} activeStep={activeStep} orientation={orientation} variant={variant} size={size} />

        <div className="stepper-content my-6">{children}</div>
      </div>
    </StepperProvider>
  );
};
